module.exports = __webpack_public_path__ + "static/media/Academie_Creteil.0bfa5143.png";